import {createApp} from 'vue'
import ConfirmDeleteProfile from './ConfirmDeleteProfile'

const el = '.kb-component--confirm-delete-profile'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((ConfirmDeleteProfileDOM)=>{
            const component = createApp(ConfirmDeleteProfile).use(Store)
            component.mount(ConfirmDeleteProfileDOM)
        })
    }
}